"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NoMoreDataRow = exports.LoaderRow = void 0;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactHighlightWords = _interopRequireDefault(require("react-highlight-words"));
var _Cell = _interopRequireDefault(require("./Cell"));
var _AutoIntl = _interopRequireDefault(require("../AutoIntl"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "dynamic_data_table-module__container___XBKGO",
  "table": "dynamic_data_table-module__table___KPe4Z",
  "header": "dynamic_data_table-module__header___InOJk",
  "hidden_scroll": "dynamic_data_table-module__hidden_scroll___smZMg",
  "cell": "dynamic_data_table-module__cell___WmECs",
  "title": "dynamic_data_table-module__title___xRq1r",
  "body": "dynamic_data_table-module__body____WpZz",
  "wrapper": "dynamic_data_table-module__wrapper___6vpz9",
  "inner": "dynamic_data_table-module__inner___DWRAj",
  "row": "dynamic_data_table-module__row___mJOCH",
  "even": "dynamic_data_table-module__even___s9yJX dynamic_data_table-module__row___mJOCH",
  "odd": "dynamic_data_table-module__odd___QReWF dynamic_data_table-module__row___mJOCH",
  "sortable": "dynamic_data_table-module__sortable___y8wPA",
  "no_wrap": "dynamic_data_table-module__no_wrap___hv7Wl",
  "msg": "dynamic_data_table-module__msg___dAka6",
  "msg_icon": "dynamic_data_table-module__msg_icon___CBpqN",
  "no_rows": "dynamic_data_table-module__no_rows___DABRw dynamic_data_table-module__msg___dAka6",
  "fetching": "dynamic_data_table-module__fetching___Udqx5 dynamic_data_table-module__msg___dAka6",
  "ellipsis": "dynamic_data_table-module__ellipsis___GMwo_",
  "highlight": "dynamic_data_table-module__highlight___VP4U1",
  "actions": "dynamic_data_table-module__actions___geMKG",
  "tooltip": "dynamic_data_table-module__tooltip___iNmbQ",
  "copy": "dynamic_data_table-module__copy___ua22X"
};
const LoaderRow = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.fetching
  }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
    displayId: "au.loadingText"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.msg_icon
  }));
};
exports.LoaderRow = LoaderRow;
const NoMoreDataRow = () => {
  return /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
    className: styles.no_rows,
    displayId: "au.table.dataEmptyMessage"
  });
};
exports.NoMoreDataRow = NoMoreDataRow;
function applyFormatters(value, column, props) {
  for (let {
    func,
    args
  } of column.formatters) {
    let argsCopy = {
      ...args
    };
    // Use passed timezone, if there is no timezone specified in tableDef settings
    if (func === 'date' && !argsCopy.timezone) {
      argsCopy.timezone = props.timezone;
    }
    if (typeof value !== 'undefined' && typeof value[func] === 'function') {
      value = (0, _isArray.default)(args) ? value[func](...args) : value[func](argsCopy);
    } else if (typeof props.formatters?.[func] === 'function') {
      if ((0, _isArray.default)(args)) {
        value = props.formatters[func]({
          args: argsCopy,
          columnDef: column,
          rowData: props.data,
          value
        });
      } else {
        value = props.formatters[func]({
          ...argsCopy,
          columnDef: column,
          rowData: props.data,
          value
        });
      }
    }
  }
  return value;
}
const Row = /*#__PURE__*/_react.default.memo(props => {
  var _context, _context2;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: props.rowRef,
    "data-index": props.index,
    className: props.index % 2 ? styles.odd : styles.even,
    role: "row"
  }, (0, _map.default)(_context = (0, _filter.default)(_context2 = props.columns).call(_context2, column => column.display)).call(_context, column => {
    const {
      property,
      ref
    } = column;
    const refProp = ref?.textProperty || ref?.idProperty;
    let value = refProp ? props.data.getIn(refProp.split('.'), '') : props.data.get(property);
    if (column.searchable && props.searchText) {
      value = /*#__PURE__*/_react.default.createElement(_reactHighlightWords.default, {
        highlightClassName: styles.highlight,
        searchWords: props.searchText.split(/\s+/),
        textToHighlight: value,
        autoEscape: true
      });
    }
    if (column.formatters) {
      value = applyFormatters(value, column, props);
    }
    return /*#__PURE__*/_react.default.createElement(_Cell.default, {
      key: `row_${props.index}_${property}`,
      style: column.style,
      className: (0, _classnames.default)({
        [styles.actions]: !!column.actionable
      }, column.className),
      tooltipRef: props.tooltipRef
    }, value);
  }));
});
Row.propTypes = {
  rowRef: T.func,
  tooltipRef: T.object
};
var _default = Row;
exports.default = _default;